import { tuitionInvoiceConstants } from '../actions/tuitionInvoice.actions';

const initialState = {
  items: [],
  loading: false,
  error: null,
  currentInvoice: null,
  invoicesByTuitionDetail: null,
  statistics: null,
  uploadedImageUrl: null,
};

export function tuitionInvoices(state = initialState, action: any) {
  switch (action.type) {
    case tuitionInvoiceConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionInvoiceConstants.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.data,
      };
    case tuitionInvoiceConstants.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionInvoiceConstants.GETBYID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionInvoiceConstants.GETBYID_SUCCESS:
      return {
        ...state,
        loading: false,
        currentInvoice: action.data,
      };
    case tuitionInvoiceConstants.GETBYID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionInvoiceConstants.GET_BY_TUITION_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionInvoiceConstants.GET_BY_TUITION_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        invoicesByTuitionDetail: action.data,
      };
    case tuitionInvoiceConstants.GET_BY_TUITION_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionInvoiceConstants.CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionInvoiceConstants.CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: [...state.items, action.data],
      };
    case tuitionInvoiceConstants.CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionInvoiceConstants.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionInvoiceConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map((item: any) =>
          item.id === action.data.id ? action.data : item
        ),
      };
    case tuitionInvoiceConstants.UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionInvoiceConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionInvoiceConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter((item: any) => item.id !== action.id),
      };
    case tuitionInvoiceConstants.DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionInvoiceConstants.GET_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionInvoiceConstants.GET_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        statistics: action.data,
      };
    case tuitionInvoiceConstants.GET_STATISTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case tuitionInvoiceConstants.UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case tuitionInvoiceConstants.UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadedImageUrl: action.data,
      };
    case tuitionInvoiceConstants.UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
